import React, { useState } from "react";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Link,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { ReactNotifications } from "react-notifications-component";
import API from "../../api";
import { colors } from "../../theme";
import Background from "../../components/Background";

import { startToast, updateToastSuccess, updateToastError } from '../../utils/notification-loading';

const StyledCard = styled(Card)`
  flex: 1;
  width: "70%";
  background-color: #1E1E1E;
  background-image: none;
  border-radius: 15px;
  /* border: 3px solid #449095; */
`;

const StyledText = styled(TextField)`
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #52a0a6; // Change to your desired focus color
  }
  & .MuiInputLabel-outlined.Mui-focused {
    color: #52a0a6; // Change to your desired label focus color
  }
`;

const Registration = ({ tipo }) => {
  const [agreePrivacy, setAgreePrivacy] = useState(false);
  const [agreeEula, setAgreeEula] = useState(false);
  const [agreeSla, setAgreeSla] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [psw, setPsw] = useState("");
  const [cpsw, setCpsw] = useState("");
  const [cname, setCname] = useState("");
  const [vat, setVat] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [prov, setProv] = useState("");
  const [cap, setCap] = useState("");
  const [cpartner] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const handleCpswChange = (e) => {
    const confirmPsw = e.target.value;
    setCpsw(confirmPsw);
    if (psw !== confirmPsw) {
      setErrorMessage("Passwords do not match");
    } else {
      setErrorMessage("");
    }
  };

  const validatePassword = (password) => {
    const lengthRegex = /^.{8,24}$/; // Lunghezza tra 8 e 24 caratteri
    const uppercaseRegex = /[A-Z]/; // Almeno una lettera maiuscola
    const numberRegex = /[0-9]/; // Almeno un numero
    const specialCharRegex = /[^A-Za-z0-9]/; // Almeno un carattere speciale

    if (!lengthRegex.test(password)) {
      return "The password must be between 8 and 24 characters long.";
    }
    if (!uppercaseRegex.test(password)) {
      return "The password must contain at least one capital letter.";
    }
    if (!numberRegex.test(password)) {
      return "The password must contain at least one number.";
    }
    if (!specialCharRegex.test(password)) {
      return "The password must contain at least one special character.";
    }
    return "";
  };

  

  const [phoneError, setPhoneError] = useState("");

  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^[0-9+]+$/; // Consente solo numeri e il carattere '+'
    if (!phoneRegex.test(phoneNumber) && phoneNumber !== "") {
      return "Enter only numbers and the '+' symbol";
    }
    return "";
  };

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value;
    setPhone(newPhone);
    const errorMessage = validatePhoneNumber(newPhone);
    setPhoneError(errorMessage);
  };

  const handlePswChange = (e) => {
    const newPsw = e.target.value;
    setPsw(newPsw);
    const errorMessage = validatePassword(newPsw);
    setPasswordError(errorMessage);
  };

  const [vatError, setVatError] = useState("");

  const validateVAT = (vat) => {
    const vatRegex = /^[A-Za-z0-9]+$/; // Consente solo lettere e numeri
    if (!vatRegex.test(vat) && vat !== "") {
      return "Enter only alphanumeric characters.";
    }
    return "";
  };

  const handleVatChange = (e) => {
    const newVat = e.target.value;
    setVat(newVat);
    const errorMessage = validateVAT(newVat);
    setVatError(errorMessage);
  };

  const [emailError, setEmailError] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(email) && email !== "") {
      return "Enter a valid email address.";
    }
    return "";
  };


  const sendEmail = async (email) => {
    try {
      const payload = {
        email: email,
        subject: "Privacy Policy, EULA & SLA by Cyberevolution",
        htmlContent: "TEST di prova numero 333333333333333333",
        nomeAllegato: "Privacy-eula-sla.pdf"
      };

      await API.sendEmailPrivacy(payload);
      
    } catch (err) {
      console.error("[sendEmail] Errore invio email:", err);
    }
  };


  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const errorMessage = validateEmail(newEmail);
    setEmailError(errorMessage);
  };

  // Handle the form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    
    var form;
    if (cpartner !== "") {
      form = {
        name: name,
        surname: surname,
        phone: phone,
        email: email,
        psw: psw,
        cpsw: cpsw,
        cname: cname,
        vat: vat,
        address: address,
        city: city,
        prov: prov,
        cap: cap,
        cpartner: cpartner,
        type: tipo,
      };
    } else {
      form = {
        name: name,
        surname: surname,
        phone: phone,
        email: email,
        psw: psw,
        cpsw: cpsw,
        cname: cname,
        vat: vat,
        address: address,
        city: city,
        prov: prov,
        cap: cap,
        type: tipo,
      };
    }
    API.postRegister(form)
      .then((response) => {
        startToast();
        if (response.status === 200) {
          if (tipo === 'reseller') {
            updateToastSuccess("Your Partner account registration request has been taken care of, you will be contacted soon to activate your new account");
            setTimeout(() => {
              window.location.href = `/${tipo}/login`;
            }, 5000)
          } else {
            window.location.href = `/${tipo}/login`;
          }
          sendEmail(email);
        } else {
          updateToastError("Operation failed, try again...");
        }
      })
      .catch((error) => {
        console.error(
          "[handleSubmit] Si è verificato un errore durante il recupero dei dati:",
          error
        );
        updateToastError("Operation failed, try again...")
      });

    // Process form data here
  };

  const allFieldsFilledAndValid =
    name &&
    surname &&
    phone &&
    email &&
    psw &&
    cpsw &&
    cname &&
    vat &&
    address &&
    city &&
    prov &&
    cap &&
    (tipo === "user" ? true : true) &&
    !passwordError &&
    !errorMessage &&
    !phoneError &&
    !emailError &&
    !vatError &&
    agreePrivacy &&
    agreeEula &&
    agreeSla;

  const [openModal, setOpenModal] = useState(false);

  const handleTermsClick = () => {
    // Apri il modal quando il testo "Terms and conditions" viene cliccato
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    // Chiudi il modal quando viene premuto il pulsante "Close"
    setOpenModal(false);
  };

  return (
    <>
    <Background/>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={2}
        style={{ minHeight: "100vh" }}
      >
        <ReactNotifications />
        <StyledCard sx={{ width: "70%", mx: 2 }}>
          {" "}
          {/* Responsive Card width */}
          <CardContent>
            <Box display="flex" flexDirection="column" alignItems="center">
              <Box display="flex" alignItems="center" marginBottom="20px">
                <img
                  src="/logoWhite.png"
                  alt="LECS Logo"
                  style={{
                    maxWidth: "60px",
                    height: "auto",
                    marginRight: "10px",
                  }}
                />
                <Typography variant="h3" component="h2">
                  LECS
                </Typography>
              </Box>
              <Typography
                variant="h3"
                component="h2"
                gutterBottom
                style={{ textAlign: "center" }}
              >
                SIGN UP
              </Typography>
            </Box>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                  <StyledText
                    required
                    label="Name"
                    fullWidth
                    margin="normal"
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <StyledText
                    required
                    label="Surname"
                    fullWidth
                    margin="normal"
                    onChange={(e) => setSurname(e.target.value)}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <StyledText
                    required
                    label="Phone Number"
                    fullWidth
                    margin="normal"
                    value={phone}
                    onChange={handlePhoneChange}
                    error={!!phoneError}
                    helperText={phoneError}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <StyledText
                    required
                    label="Email"
                    type="email"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={handleEmailChange}
                    error={!!emailError}
                    helperText={emailError}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <StyledText
                    required
                    label="Password"
                    type="password"
                    fullWidth
                    margin="normal"
                    onChange={handlePswChange}
                    error={!!passwordError}
                    helperText={passwordError}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <StyledText
                    required
                    label="Confirm Password"
                    type="password"
                    fullWidth
                    margin="normal"
                    onChange={handleCpswChange}
                    error={!!errorMessage}
                    helperText={errorMessage}
                  />
                </Grid>
                {tipo === "user" ? (
                  <>
                    <Grid size={{ xs: 9 }}>
                      <StyledText
                        required
                        label="Company Name"
                        fullWidth
                        margin="normal"
                        onChange={(e) => setCname(e.target.value)}
                      />
                    </Grid>
                    <Grid size={{ xs: 3 }}>
                      <StyledText
                        required
                        label="VAT"
                        fullWidth
                        margin="normal"
                        value={vat}
                        onChange={handleVatChange}
                        error={!!vatError}
                        helperText={vatError}
                      />
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid size={{ xs: 7 }}>
                      <StyledText
                        required
                        label="Company Name"
                        fullWidth
                        margin="normal"
                        onChange={(e) => setCname(e.target.value)}
                      />
                    </Grid>
                    <Grid size={{ xs: 3 }}>
                      <StyledText
                        required
                        label="VAT"
                        fullWidth
                        margin="normal"
                        value={vat}
                        onChange={handleVatChange}
                        error={!!vatError}
                        helperText={vatError}
                      />
                    </Grid>
                  </>
                )}
                <Grid size={{ xs: 5 }}>
                  <StyledText
                    required
                    label="Address"
                    fullWidth
                    margin="normal"
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </Grid>
                <Grid size={{ xs: 3 }}>
                  <StyledText
                    required
                    label="City"
                    fullWidth
                    margin="normal"
                    onChange={(e) => setCity(e.target.value)}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <StyledText
                    required
                    label="Prov"
                    fullWidth
                    margin="normal"
                    onChange={(e) => setProv(e.target.value)}
                  />
                </Grid>
                <Grid size={{ xs: 6, sm: 3 }}>
                  <StyledText
                    required
                    label="Postal Code"
                    fullWidth
                    margin="normal"
                    onChange={(e) => setCap(e.target.value)}
                  />
                </Grid>
              </Grid>

              <Typography variant="body2" sx={{ mt: 3, fontWeight: 300 }}>
                You must carefully review and accept the 'Privacy Policy', 'EULA', and 'SLA' documents prior to completing registration.
              </Typography>

              <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                {/* RIGA 1 - Privacy */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="agreePrivacy"
                        checked={agreePrivacy}
                        onChange={(e) => setAgreePrivacy(e.target.checked)}
                      />
                    }
                    label=""
                  />
                  <Typography
                    variant="body2"
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      marginLeft: "-15px",
                    }}
                    onClick={handleTermsClick}
                  >
                    Privacy Policy
                  </Typography>
                </div>

                {/* RIGA 2 - EULA */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="agreeEula"
                        checked={agreeEula}
                        onChange={(e) => setAgreeEula(e.target.checked)}
                      />
                    }
                    label=""
                  />
                  <Typography
                    variant="body2"
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      marginLeft: "-15px",
                    }}
                    onClick={() => {
                      window.open("/EULA.html", "_blank");
                    }}
                  >
                    EULA
                  </Typography>
                </div>

                {/* RIGA 3 - SLA */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="agreeSla"
                        checked={agreeSla}
                        onChange={(e) => setAgreeSla(e.target.checked)}
                      />
                    }
                    label=""
                  />
                  <Typography
                    variant="body2"
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      marginLeft: "-15px",
                    }}
                    onClick={() => {
                      window.open("/SLA.html", "_blank");
                    }}
                  >
                    SLA
                  </Typography>
                </div>

                {/* MODAL PRIVACY */}
                <Dialog open={openModal} onClose={handleCloseModal}>
                  <DialogTitle>Privacy Policy</DialogTitle>
                  <DialogContent>
                    <div class="container">
                      <div class="row p-4 text-center">
                        <h3>PRIVACY POLICY</h3>
                      </div>
                      <div class="row p-2">
                        <p>
                          <b>
                            Information provided pursuant to and for the purposes of Art.
                            13 of EU GDPR 2016/679 on the protection of natural persons
                            with regard to the processing of personal data and of the
                            Italian Code 196/2003 as subsequently amended and supplemented.
                          </b>
                        </p>
                      </div>
                      <div class="row p-2">
                        <table>
                          <tr>
                            <td>Data subjects</td>
                            <td>LECS platform users</td>
                          </tr>
                          <tr>
                            <td>Data Controller</td>
                            <td>
                              CYBER EVOLUTION SRL, represented by its current legal
                              representative
                            </td>
                          </tr>
                          <tr>
                            <td>Applicable legislation</td>
                            <td>
                              The Company processes personal data of the data subjects in
                              compliance with EU GDPR 2016/679, applicable National Data
                              Protection Laws, as well as with the provisions issued by the
                              Italian Data Protection Authority (“Garante”).
                            </td>
                          </tr>
                          <tr>
                            <td>Data collection and nature of provision</td>
                            <td>
                              Identification and contact data will be processed; failure to
                              provide such data will prevent the use of the Lecs services
                              managed by the platform.
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Purpose and legal basis of processing
                            </td>
                            <td>
                              The processing of such data is aimed at registering the user
                              on the platform https://securitylecs.com. The processing is
                              lawful as it is necessary for the execution of the contract
                              between the parties (Art. 6, para. 1, lett. b).
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Processing methods and data recipients
                            </td>
                            <td>
                              Processing methods are digital and electronic; the
                              registration phase is automated and managed by the IT system
                              without the aid of operators. The identification data entered
                              will be used for assigning and activating the platform to the
                              customer’s license code, while contact details will be used
                              to send alerts.
                            </td>
                          </tr>
                          <tr>
                            <td>Disclosure and transfer of data abroad</td>
                            <td>
                              No disclosure, transfer, or dissemination of data. If, for
                              technical and/or operational reasons, it becomes necessary to
                              transfer some of the collected data to IT systems located
                              outside the EU, the processing will be carried out in
                              accordance with the applicable legislation.
                            </td>
                          </tr>
                          <tr>
                            <td>Data retention period</td>
                            <td>
                              The data will be stored and updated for as long as the
                              license for the services remains valid; in the absence of
                              renewal, the data will be deleted.
                            </td>
                          </tr>
                          <tr>
                            <td>Exercisable rights</td>
                            <td>
                              The rights provided within the limits and under the
                              conditions of Articles 15 to 23 of the GDPR — such as the
                              right of access, rectification and updating, erasure,
                              restriction or objection, as well as the right to portability
                              — may be exercised where applicable.
                            </td>
                          </tr>
                          <tr>
                            <td>Right to lodge a complaint with the Authority</td>
                            <td>
                              Data subjects who believe that the processing of their
                              personal data is in violation of GDPR 2016/679 have the right
                              to lodge a complaint with the supervisory authority “Garante
                              per la protezione dei dati personali” by downloading the form
                              available at www.gpdp.it and submitting it in person at the
                              offices, by registered mail, or by certified email (updated
                              contact details available on the website), as provided by
                              Art. 77 of GDPR 2016/1279. They also have the right to bring
                              proceedings before the competent courts (Art. 79), including
                              claims for compensation.
                            </td>
                          </tr>
                          <tr>
                            <td>Data Controller’s contact details</td>
                            <td>
                              The Data Controller, to whom you may turn to exercise your
                              rights, is CYBER EVOLUTION SRL. Requests for information, the
                              exercise of rights, or to obtain the list of appointed
                              processors may be sent to the following e-mail address:
                              info@cyberevolution.it
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </DialogContent>
                  <Button style={{ color: "#fff" }} onClick={handleCloseModal}>
                    Close
                  </Button>
                </Dialog>
              </div>

              <Box mt={2}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  disabled={!allFieldsFilledAndValid}
                  sx={{
                    backgroundColor: "#2d2d2d !important",
                    mt: 3,
                    mb: 2,
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D !important",
                    },
                  }}
                >
                  Sign Up
                </Button>
              </Box>
              <Box mt={2} display="flex" justifyContent="center">
                <Link
                  href={`/${tipo}/login`}
                  style={{
                    color: colors.grey[100],
                  }}
                  variant="body2"
                >
                  Do you already have an account ? Sign in
                </Link>
              </Box>
            </form>
          </CardContent>
        </StyledCard>
      </Box>
      </>
  );
};

export default Registration;
